import cx from "classnames";
import { Button, Modal, FlexBox, Input } from "components";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { setGeneralDetails } from "Slices";
import { validateEmail } from "utils";
import "./styles.scss";
import { EmailModalProps } from "./types";
const EmailModal: React.FC<EmailModalProps> = ({
  visible,
  onClose,
  action,
}) => {
  const [fromInputValue, setFromInputValue] = useState("");
  const [toInputValue, setToInputValue] = useState("");
  const [toInputs, setToInputs]: any = useState([]);
  const [emailBody, setEmailBody] = useState("");
  const toInputRef: any = useRef(null);
  useEffect(() => {
    if (visible) {
      setFromInputValue("");
      setToInputValue("");
      setToInputs([]);
      setEmailBody(
        `Steps to integrate 'Login with WhatsApp' button:
1) Create an application in the OTPless Dashboard
2) Use the Application keys to integrate SDK / Rest API
...
        `
      );
    }
  }, [visible]);

  return (
    <Modal
      modalHeader={
        <p className="font-medium clr-theme">Connect us with your tech team</p>
      }
      onClose={onClose}
      visible={visible}
      className="email-modal"
    >
      <FlexBox
        alignCenter
        justifyBetween
        className="w-100 to-input fs-18 border-bottom theme-border animated fadeInUp pd-v-15 delay-02s"
      >
        <p className="font-light mr-r-20">To</p>
        <FlexBox flexWrap alignCenter className="w-100">
          {toInputs.length > 0 &&
            toInputs.map((item: string, index: number) => {
              return (
                <p className="full-border pd-5 br-9 fs-14 mr-r-5">
                  {item}
                  <span
                    className="mr-l-5 clicking-animation"
                    onClick={() => {
                      let tempToInputs: any = toInputs;
                      tempToInputs = tempToInputs.filter(
                        (filteredItem) => filteredItem !== item
                      );
                      setToInputs([...tempToInputs]);
                    }}
                  >
                    &#10005;
                  </span>
                </p>
              );
            })}
          <Input
            value={toInputValue}
            inputRef={toInputRef}
            onChange={({ target }) => {
              const value = target.value;
              setToInputValue(value);
            }}
            onEnter={() => {
              if (validateEmail(toInputValue)) {
                const tempToInputs: any = toInputs;
                if (!tempToInputs.includes(toInputValue)) {
                  tempToInputs.push(toInputValue);
                  setToInputs([...tempToInputs]);
                }
                setToInputValue("");
                toInputRef.current.focus();
              } else {
                toast.error("Invalid work email id");
              }
            }}
            placeholder={
              toInputs.length > 0
                ? "Add more"
                : "Enter your tech team email address"
            }
            className="no-border fs-16"
            others={{
              onKeyDown: (e) => {
                if (
                  [e.key, e.code].includes("Tab") ||
                  [e.key, e.code].includes("Space") ||
                  [e.key, e.code].includes("Comma")
                ) {
                  if (validateEmail(toInputValue)) {
                    const tempToInputs: any = toInputs;
                    if (!tempToInputs.includes(toInputValue)) {
                      tempToInputs.push(toInputValue);
                      setToInputs([...tempToInputs]);
                    }
                    setTimeout(() => {
                      setToInputValue("");
                      toInputRef.current.focus();
                    }, 0);
                  } else {
                    toast.error("Invalid work email id");
                  }
                }
              },
              onBlur: () => {
                if (toInputValue) {
                  if (validateEmail(toInputValue)) {
                    const tempToInputs: any = toInputs;
                    if (!tempToInputs.includes(toInputValue)) {
                      tempToInputs.push(toInputValue);
                      setToInputs([...tempToInputs]);
                    }
                    setTimeout(() => {
                      setToInputValue("");
                      toInputRef.current.focus();
                    }, 0);
                  } else {
                    toast.error("Invalid work email id");
                  }
                }
              },
            }}
          />
        </FlexBox>
      </FlexBox>
      {/* <FlexBox
        alignCenter
        justifyBetween
        className="w-100 from-input fs-18 border-bottom animated fadeInUp pd-v-15 delay-01s"
      >
        <p className="font-medium w-15">From</p>
        <Input
          value={fromInputValue}
          onChange={({ target }) => {
            const value = target.value;
            setFromInputValue(value);
          }}
          placeholder="Enter your email address"
          className="no-border fs-16"
          type="email"
        />
      </FlexBox> */}
      <FlexBox
        justifyBetween
        alignCenter
        className="pd-v-20 border-bottom fs-16 animated fadeInUp delay-03s"
      >
        <p className="font-light mr-r-20">Subject</p>
        <p className="w-100 font-medium fs-14">
          How to integrate "Login with WhatsApp"
        </p>
      </FlexBox>
      <div className="mr-v-20 full-border br-9 pd-10 animated fadeInUp delay-04s">
        <Input
          type="textarea"
          value={emailBody}
          onChange={({ target }) => {
            const value = target.value;
            setEmailBody(value);
          }}
          className="fs-14 no-border"
          others={{
            rows: "4",
          }}
        />
      </div>
      <FlexBox justifyEnd alignCenter>
        {/* <p className="fs-12 clr-disabled">Send a message to your team</p> */}
        <Button
          text={"Send Email"}
          onClick={() => {
            // if (validateEmail(fromInputValue)) {
            if (toInputValue) {
              toast.error("Invalid team email id");
            } else {
              if (toInputs.length > 0) {
                if (emailBody) {
                  setGeneralDetails({
                    initiateEmail: {
                      to: toInputs,
                      body: emailBody,
                    },
                  });
                  action({
                    // from: fromInputValue,
                    to: toInputs,
                    body: emailBody,
                  });
                } else {
                  toast.error("Enter email body!");
                }
              } else {
                toast.error("Enter your tech team email id");
              }
            }
            // } else {
            //   toast.error("Enter your valid email id");
            // }
          }}
          className="send-button no-wrap"
        />
      </FlexBox>
      {/* <p className="mr-t-10 fs-12 clr-disabled animated fadeInUp delay-05s font-medium">
        <span className="font-heavy">Note:</span> The complete integration
        process will be sent along with this email.
      </p> */}
    </Modal>
  );
};
export default EmailModal;
